import {Devices, DeviceSizes, Breakpoints} from '../records/systemStateRecord';
import {Map} from 'immutable';
import windowActions from '../actions/windowActions.js';

function getInitialSize() {
    let defaultSize = {
        height: 900,
        width: 1024
    };

    if (typeof window !== 'undefined') {
        defaultSize.height = window.innerHeight;
        defaultSize.width = window.innerWidth;
    }

    return defaultSize;
}

// Returns 'desktop' | 'tablet' | 'mobile'
function determineDevice(height, width) {
    if (width < Breakpoints.xs) {
        return Devices.mobile;
    }
    if (width < Breakpoints.md) {
        return Devices.tablet;
    }

    return Devices.desktop;
}

// Returns 'xs' | 'sm' | 'md' | 'lg' | 'xl'
function determineDeviceSize(height, width) {
    for (let point in Breakpoints) {
        if ({}.hasOwnProperty.call(Breakpoints, point)) {
            if (width < Breakpoints[point]) {
                return DeviceSizes[point];
            }
        }
    }
    return 'xl';
}

// Returns {isDesktop: true | false, isMobile: true | false, isTablet: true | false}
function determineDeviceState(height, width) {
    const device = determineDevice(height, width);

    return {
        isDesktop: device === Devices.desktop,
        isMobile: device === Devices.mobile,
        isTablet: device === Devices.tablet
    };
}

function determineStickyState(breakpointMap, yPosition) {
    const stickyStateMap = {};
    let current;

    Object.keys(breakpointMap).forEach((key) => {
        current = breakpointMap[key];

        if (!current.initialized && current.callback) {
            current.value = current.callback();
            current.initialized = true;
        }

        stickyStateMap[key] = current.value <= yPosition;
    });

    return new Map(stickyStateMap);
}

const stickyMap = {};

function registerStickyPosition(store, action = {payload: {key: 0, value: 0}}) {
    let {
        key,
        value
    } = action.payload;

    let callback;
    let initialized = true;

    if (typeof value === 'function') {
        callback = value;
        value = -1;
        initialized = false;
    }

    if (typeof value === 'undefined' && stickyMap[key]) {
        delete stickyMap[key];
    } else {
        stickyMap[key] = {
            key,
            callback,
            value,
            initialized
        };
    }

    return stickyMap;
}

function updateStickyValues() {
    Object.keys(stickyMap).forEach((key) => {
        let value = stickyMap[key].value;

        if (stickyMap[key].callback) {
            value = stickyMap[key].callback();
        }

        stickyMap[key].value = value;
        stickyMap[key].initialized = true;
    });
}

function windowSizeChanged(store, action = {payload: {height: 0, width: 0, yPosition: 0}}) {
    const {
        height,
        width,
        yPosition
    } = action.payload;
    const isMobileUserAgent = store.getState().systemReducer.isMobileUserAgent;

    const windowSize = {width, height};
    const device = determineDevice(height, width);
    const deviceSize = determineDeviceSize(height, width);
    const deviceState = determineDeviceState(height, width);
    // Invalidate all scroll breakpoints and request new values
    updateStickyValues();

    const stickyState = determineStickyState(stickyMap, yPosition);

    // Lock the phone into mobile if mobile user agent
    if (!isMobileUserAgent) {
        store.dispatch(windowActions.windowDeviceUpdated(deviceState, windowSize, device, deviceSize));
    }
    store.dispatch(windowActions.stickyPositionUpdated(stickyState));
}

/* istanbul ignore next */
function windowScrolled(store, action = {payload: {data: {yPosition: 0}}}) {
    const {yPosition} = action.payload;
    const stickyState = determineStickyState(stickyMap, yPosition);

    store.dispatch(windowActions.stickyPositionUpdated(stickyState));
}

export {
    determineDevice,
    determineDeviceSize,
    determineDeviceState,
    determineStickyState,
    getInitialSize,
    registerStickyPosition,
    updateStickyValues,
    windowScrolled,
    windowSizeChanged
};
